import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-issues-from-drivers',
    templateUrl: './issues-from-drivers.component.html',
    styleUrls: ['./issues-from-drivers.component.scss'],
    standalone: false
})
export class IssuesFromDriversComponent implements OnInit {
  issues = [
    { severity: 'high', icon: 'fa-exclamation-triangle', registration: 'REG-2201', description: 'Brake warning light — reported by J. Smith' },
    { severity: 'medium', icon: 'fa-exclamation-circle', registration: 'REG-1187', description: 'Tyre wear — reported by A. Patel' },
    { severity: 'low', icon: 'fa-info-circle', registration: 'REG-3390', description: 'Minor bodywork scuff — reported by R. Jones' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
